import styled from 'styled-components';


const media = {

    tablet:
        '@media (max-width: 768px)',

    mobile:
        '@media (max-width: 520px)'

};


/*
====================================
CONTENEDOR GENERAL
====================================
*/

export const ContenedorObjetivos =
    styled.div`

        width:
            100%;

        padding:
            22px 44px 30px 44px;

        box-sizing:
            border-box;


        ${media.tablet} {

            padding:
                18px 20px 24px 20px;

        }


        ${media.mobile} {

            padding:
                14px 12px 20px 12px;

        }

    `;


/*
====================================
ÁREAS
====================================
*/

export const AreasObjetivos =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            center;

        gap:
            6px;

        flex-wrap:
            wrap;

        padding-bottom:
            14px;

        margin-bottom:
            18px;

        border-bottom:
            1.5px solid #EDEDE9;

        box-sizing:
            border-box;

    `;


export const BotonAreaObjetivo =
    styled.button`

        border:
            none;

        background:
            ${props =>
                props.activo
                    ? '#23AAAF'
                    : 'transparent'
            };

        color:
            ${props =>
                props.activo
                    ? '#FFFFFF'
                    : '#646464'
            };

        padding:
            10px 16px;

        border-radius:
            10px;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            color 0.15s ease;


        &:hover {

            background:
                ${props =>
                    props.activo
                        ? '#23AAAF'
                        : '#EFEFEA'
                };

        }


        ${media.mobile} {

            padding:
                9px 11px;

            font-size:
                11px;

        }

    `;


/*
====================================
DISPONIBLES / ASIGNADOS
====================================
*/

export const TabsObjetivos =
    styled.div`

        width:
            100%;

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            4px;

        padding:
            4px;

        margin-bottom:
            22px;

        background:
            #EFEFEA;

        border-radius:
            12px;

        box-sizing:
            border-box;

    `;


export const TabObjetivo =
    styled.button`

        width:
            100%;

        border:
            none;

        border-radius:
            9px;

        padding:
            13px;

        background:
            ${props =>
                props.activo
                    ? '#23AAAF'
                    : 'transparent'
            };

        color:
            ${props =>
                props.activo
                    ? '#FFFFFF'
                    : '#646464'
            };

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.02em;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            color 0.15s ease;


        &:hover {

            background:
                ${props =>
                    props.activo
                        ? '#23AAAF'
                        : '#FFFFFF'
                };

        }


        ${media.mobile} {

            padding:
                11px 8px;

            font-size:
                11px;

        }

    `;


/*
====================================
CONTENIDO
====================================
*/

export const PanelObjetivos =
    styled.div`

        width:
            100%;

        min-width:
            0;

        box-sizing:
            border-box;

    `;

/*
====================================
OBJETIVOS ASIGNADOS
====================================
*/

export const KanbanObjetivos =
    styled.div`

        width:
            100%;

        min-height:
            430px;

        display:
            grid;

        grid-template-columns:
            repeat(
                3,
                minmax(
                    0,
                    1fr
                )
            );

        box-sizing:
            border-box;


        @media (
            max-width: 900px
        ) {

            grid-template-columns:
                1fr;

            gap:
                24px;

        }

    `;


/*
====================================
COLUMNA
====================================
*/

export const ColumnaObjetivos =
    styled.div`

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        padding:
            0 26px;

        box-sizing:
            border-box;


        &:not(:first-child) {

            border-left:
                1.5px solid #EDEDE9;

        }


        &:first-child {

            padding-left:
                0;

        }


        &:last-child {

            padding-right:
                0;

        }


        @media (
            max-width: 900px
        ) {

            padding:
                0;

            &:not(:first-child) {

                border-left:
                    none;

                border-top:
                    1.5px solid #EDEDE9;

                padding-top:
                    22px;

            }

        }

    `;


/*
====================================
TÍTULO DE COLUMNA
====================================
*/

export const TituloColumnaObjetivos =
    styled.div`

        width:
            100%;

        margin-bottom:
            16px;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

        text-align:
            center;

        text-transform:
            uppercase;

        letter-spacing:
            0.03em;

    `;


/*
====================================
LISTADO
====================================
*/

export const ListaColumnaObjetivos =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        gap:
            10px;

        box-sizing:
            border-box;

    `;


/*
====================================
TARJETA
====================================
*/

export const TarjetaObjetivo =
    styled.div`

        width:
            100%;

        min-height:
            48px;

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            10px;

        padding:
            11px 13px;

        background:
            #F8F8F6;

        border-radius:
            10px;

        box-sizing:
            border-box;

        transition:
            background 0.15s ease;


        &:hover {

            background:
                #EFEFEA;

        }

    `;


export const NombreObjetivoAsignado =
    styled.div`

        flex:
            1;

        min-width:
            0;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            500;

        line-height:
            1.4;

        overflow-wrap:
            anywhere;

    `;


/*
====================================
FLECHAS
====================================
*/

export const ControlesObjetivo =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            2px;

        flex-shrink:
            0;

    `;


export const BotonMoverObjetivo =
    styled.button`

        width:
            28px;

        height:
            28px;

        padding:
            0;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            none;

        border-radius:
            50%;

        background:
            transparent;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            opacity 0.15s ease;


        &:hover:not(:disabled) {

            background:
                rgba(
                    35,
                    170,
                    175,
                    0.12
                );

        }


        &:disabled {

            opacity:
                0.35;

            cursor:
                default;

        }

    `;


/*
====================================
COLUMNA VACÍA
====================================
*/

export const SinObjetivosColumna =
    styled.div`

        width:
            100%;

        padding:
            24px 10px;

        color:
            #B5B5B0;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-style:
            italic;

        text-align:
            center;

        box-sizing:
            border-box;

    `;

/*
====================================
OBJETIVOS DISPONIBLES
====================================
*/

export const ContenedorDisponiblesObjetivos =
    styled.div`

        width:
            100%;

        min-width:
            0;

        display:
            flex;

        flex-direction:
            column;

        box-sizing:
            border-box;

    `;


/*
====================================
ENCABEZADO
====================================
*/

export const EncabezadoDisponibles =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            15px;

        margin-bottom:
            8px;

    `;


export const TituloDisponibles =
    styled.div`

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.03em;

    `;


export const ContenedorNuevoObjetivo =
    styled.div`

        flex-shrink:
            0;

        display:
            flex;

        align-items:
            center;


        /*
        El botón + actual todavía viene
        de ObjetivosNuevos.

        Lo contenemos acá sin cambiar
        su lógica ni su modal.
        */

        button {

            cursor:
                pointer;

        }

    `;


/*
====================================
AYUDA
====================================
*/

export const AyudaObjetivoNuevo =
    styled.div`

        width:
            100%;

        max-width:
            960px;

        display:
            flex;

        align-items:
            flex-start;

        gap:
            10px;

        padding:
            11px 14px;

        margin:
            4px 0 16px 0;

        background:
            #EFEFEA;

        border-radius:
            10px;

        box-sizing:
            border-box;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        line-height:
            1.5;

    `;


export const IconoAyudaObjetivo =
    styled.div`

        width:
            18px;

        height:
            18px;

        min-width:
            18px;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            1.5px solid #23AAAF;

        border-radius:
            50%;

        color:
            #23AAAF;

        font-size:
            11px;

        font-weight:
            700;

        margin-top:
            1px;

    `;


export const TextoAyudaObjetivo =
    styled.div`

        strong {

            color:
                #2B2B2B;

        }

    `;


/*
====================================
LEYENDA
====================================
*/

export const LeyendaDisponibles =
    styled.div`

        width:
            100%;

        display:
            flex;

        align-items:
            center;

        gap:
            22px;

        flex-wrap:
            wrap;

        margin-bottom:
            18px;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

    `;


export const ItemLeyendaObjetivo =
    styled.div`

        display:
            flex;

        align-items:
            center;

        gap:
            8px;

    `;


export const PuntoEstadoObjetivo =
    styled.span`

        width:
            10px;

        height:
            10px;

        min-width:
            10px;

        border-radius:
            50%;

        background:
            ${props =>
                props.agregado
                    ? '#6FBF7B'
                    : '#E4756B'
            };

    `;


/*
====================================
GRILLA
====================================
*/

export const GrillaObjetivosDisponibles =
    styled.div`

        width:
            100%;

        display:
            grid;

        grid-template-columns:
            repeat(
                2,
                minmax(
                    0,
                    1fr
                )
            );

        gap:
            10px 20px;

        box-sizing:
            border-box;


        ${media.tablet} {

            grid-template-columns:
                1fr;

        }

    `;


/*
====================================
TARJETA DISPONIBLE
====================================
*/

export const TarjetaObjetivoDisponible =
    styled.button`

        width:
            100%;

        min-width:
            0;

        min-height:
            46px;

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            12px;

        padding:
            11px 14px;

        border:
            none;

        border-radius:
            10px;

        background:
            #F8F8F6;

        box-sizing:
            border-box;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-weight:
            500;

        text-align:
            left;

        cursor:
            pointer;

        transition:
            background 0.15s ease,
            opacity 0.15s ease;


        &:hover:not(:disabled) {

            background:
                #EDEDE9;

        }


        &:disabled {

            cursor:
                default;

            opacity:
                0.65;

        }

    `;


export const NombreObjetivoDisponible =
    styled.span`

        flex:
            1;

        min-width:
            0;

        overflow-wrap:
            anywhere;

        line-height:
            1.4;

    `;


/*
====================================
SIN OBJETIVOS
====================================
*/

export const SinObjetivosDisponibles =
    styled.div`

        grid-column:
            1 / -1;

        width:
            100%;

        padding:
            45px 10px;

        box-sizing:
            border-box;

        color:
            #B5B5B0;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            12px;

        font-style:
            italic;

        text-align:
            center;

    `;

/*
====================================
NUEVO OBJETIVO
====================================
*/

export const BotonNuevoObjetivo =
    styled.button`

        width:
            36px;

        height:
            36px;

        min-width:
            36px;

        padding:
            0;

        display:
            flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            none;

        border-radius:
            50%;

        background:
            #23AAAF;

        color:
            #FFFFFF;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            24px;

        font-weight:
            400;

        line-height:
            1;

        cursor:
            pointer;

        transition:
            opacity 0.15s ease,
            transform 0.15s ease;


        &:hover {

            opacity:
                0.88;

            transform:
                scale(1.03);

        }

    `;


/*
====================================
CONTENIDO MODAL
====================================
*/

export const ContenidoModalObjetivo =
    styled.div`

        width:
            100%;

        display:
            flex;

        flex-direction:
            column;

        box-sizing:
            border-box;

    `;


export const TituloModalObjetivo =
    styled.div`

        margin-bottom:
            10px;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            17px;

        font-weight:
            600;

        line-height:
            1.4;

    `;


export const TextoModalObjetivo =
    styled.p`

        margin:
            0 0 22px 0;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        line-height:
            1.6;

    `;


export const LabelModalObjetivo =
    styled.label`

        margin-bottom:
            7px;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            10px;

        font-weight:
            600;

        text-transform:
            uppercase;

        letter-spacing:
            0.03em;

    `;


export const InputModalObjetivo =
    styled.input`

        width:
            100%;

        min-height:
            42px;

        padding:
            10px 13px;

        border:
            1.5px solid #DDDDD8;

        border-radius:
            10px;

        outline:
            none;

        background:
            #FFFFFF;

        color:
            #2B2B2B;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            13px;

        box-sizing:
            border-box;


        &:focus {

            border-color:
                #23AAAF;

        }

    `;


/*
====================================
ACCIONES MODAL
====================================
*/

export const AccionesModalObjetivo =
    styled.div`

        width:
            100%;

        display:
            flex;

        justify-content:
            flex-end;

        align-items:
            center;

        gap:
            10px;

        margin-top:
            22px;


        ${media.mobile} {

            flex-direction:
                column-reverse;

        }

    `;


export const BotonCancelarObjetivo =
    styled.button`

        min-height:
            38px;

        padding:
            9px 18px;

        border:
            1.5px solid #DDDDD8;

        border-radius:
            20px;

        background:
            #FFFFFF;

        color:
            #646464;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        font-weight:
            600;

        cursor:
            pointer;


        &:hover {

            background:
                #F8F8F6;

        }


        ${media.mobile} {

            width:
                100%;

        }

    `;


export const BotonGuardarObjetivo =
    styled.button`

        min-height:
            40px;

        padding:
            10px 22px;

        border:
            none;

        border-radius:
            20px;

        background:
            #23AAAF;

        color:
            #FFFFFF;

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        font-weight:
            600;

        cursor:
            pointer;

        transition:
            opacity 0.15s ease;


        &:hover {

            opacity:
                0.88;

        }


        &:disabled {

            opacity:
                0.55;

            cursor:
                default;

        }


        ${media.mobile} {

            width:
                100%;

        }

    `;


export const MensajeModalObjetivo =
    styled.div`

        width:
            100%;

        margin-top:
            12px;

        color:
            ${props =>
                props.error
                    ? '#D76970'
                    : '#646464'
            };

        font-family:
            'Montserrat',
            sans-serif;

        font-size:
            11px;

        text-align:
            center;

    `;


/*
====================================
ESTILO REACT MODAL
====================================
*/

export const estilosModalObjetivo = {

    overlay: {

        backgroundColor:
            'rgba(0, 0, 0, 0.35)',

        display:
            'flex',

        alignItems:
            'center',

        justifyContent:
            'center',

        zIndex:
            2000

    },

    content: {

        position:
            'relative',

        inset:
            'auto',

        width:
            'min(560px, calc(100vw - 30px))',

        maxHeight:
            'calc(100vh - 40px)',

        overflowY:
            'auto',

        padding:
            '28px',

        border:
            'none',

        borderRadius:
            '16px',

        boxShadow:
            '0px 12px 35px rgba(0, 0, 0, 0.18)',

        boxSizing:
            'border-box'

    }

};